import * as CONST from 'common/const';
import createReducer from './createReducer';

const initialState = {
  loading: false,
  columnMetadata: [],
  error: '',
  initialized: false
}

export default createReducer(initialState, {
  [CONST.FETCH_COLUMN_METADATA_REQUEST]: state => ({
    ...state,
    loading: true,
    error: '',
    initialized: true
  }),

  [CONST.FETCH_COLUMN_METADATA_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      error: '',
      columnMetadata: action.columnMetadata,
      initialized: true
    }),

  [CONST.FETCH_COLUMN_METADATA_FAILURE]: (state, e) => ({
    ...state,
    loading: false,
    error: e,
    initialized: false
  }),
});
